export function registerComponent<T extends object>(name: string, instance: T): T {
    (window.skyComponents ??= {})[name] = instance;
    return instance;
}
